import { RESET_USER } from ".";

export const types = {
  GET_FOROS_MATERIAS_BEGINS: 'FOROS/GET_FOROS_MATERIAS_BEGINS',
  GET_FOROS_MATERIAS_SUCCESS: 'FOROS/GET_FOROS_MATERIAS_SUCCESS',
  GET_FOROS_MATERIAS_FAILURE: 'FOROS/GET_FOROS_MATERIAS_FAILURE',

  GET_FOROS_HILOS_BEGINS: 'FOROS/GET_FOROS_HILOS_BEGINS',
  GET_FOROS_HILOS_SUCCESS: 'FOROS/GET_FOROS_HILOS_SUCCESS',
  GET_FOROS_HILOS_FAILURE: 'FOROS/GET_FOROS_HILOS_FAILURE',

  GET_FORO_HILO_DETALLE_BEGINS: 'FOROS/GET_FORO_HILO_DETALLE_BEGINS',
  GET_FORO_HILO_DETALLE_SUCCESS: 'FOROS/GET_FORO_HILO_DETALLE_SUCCESS',
  GET_FORO_HILO_DETALLE_FAILURE: 'FOROS/GET_FORO_HILO_DETALLE_FAILURE',

  POST_FORO_HILO_BEGINS: 'FOROS/POST_FORO_HILO_BEGINS',
  POST_FORO_HILO_SUCCESS: 'FOROS/POST_FORO_HILO_SUCCESS',
  POST_FORO_HILO_FAILURE: 'FOROS/POST_FORO_HILO_FAILURE',
  RESET_POST_FORO_HILO: 'FOROS/RESET_POST_FORO_HILO',

  POST_FORO_RESPUESTA_BEGINS: 'FOROS/POST_FORO_RESPUESTA_BEGINS',
  POST_FORO_RESPUESTA_SUCCESS: 'FOROS/POST_FORO_RESPUESTA_SUCCESS',
  POST_FORO_RESPUESTA_FAILURE: 'FOROS/POST_FORO_RESPUESTA_FAILURE',
  RESET_POST_FORO_RESPUESTA: 'FOROS/RESET_POST_FORO_RESPUESTA',

  DELETE_FORO_HILO_BEGINS: 'FOROS/DELETE_FORO_HILO_BEGINS',
  DELETE_FORO_HILO_SUCCESS: 'FOROS/DELETE_FORO_HILO_SUCCESS',
  DELETE_FORO_HILO_FAILURE: 'FOROS/DELETE_FORO_HILO_FAILURE',
  RESET_DELETE_FORO_HILO: 'FOROS/RESET_DELETE_FORO_HILO',

  DELETE_FORO_RESPUESTA_BEGINS: 'FOROS/DELETE_FORO_RESPUESTA_BEGINS',
  DELETE_FORO_RESPUESTA_SUCCESS: 'FOROS/DELETE_FORO_RESPUESTA_SUCCESS',
  DELETE_FORO_RESPUESTA_FAILURE: 'FOROS/DELETE_FORO_RESPUESTA_FAILURE',
  RESET_DELETE_FORO_RESPUESTA: 'FOROS/RESET_DELETE_FORO_RESPUESTA',

  CLEAR_FORO_HILOS: 'FOROS/CLEAR_FORO_HILOS',
  CLEAR_FORO_DETALLE: 'FOROS/CLEAR_FORO_DETALLE',
}

export const initialState = {
  materias: [],
  materiasFetching: false,
  materiasError: null,

  hilos: {
    items: [],
    page: 1,
    pageSize: 100,
    totalItems: 0,
    totalPages: 0,
  },
  hilosMateriaId: null,
  hilosFetching: false,
  hilosError: null,

  hiloDetalle: null,
  hiloDetalleFetching: false,
  hiloDetalleError: null,

  hiloStatus: null,
  hiloStatusData: null,
  hiloStatusFetching: false,
  hiloStatusError: null,

  respuestaStatus: null,
  respuestaStatusData: null,
  respuestaStatusFetching: false,
  respuestaStatusError: null,

  deleteHiloStatus: null,
  deleteHiloStatusData: null,
  deleteHiloStatusFetching: false,
  deleteHiloStatusError: null,

  deleteRespuestaStatus: null,
  deleteRespuestaStatusData: null,
  deleteRespuestaStatusFetching: false,
  deleteRespuestaStatusError: null,
}

const ForosReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_USER:
      return initialState;

    case types.GET_FOROS_MATERIAS_BEGINS:
      return {
        ...state,
        materiasFetching: true,
        materiasError: null,
      };
    case types.GET_FOROS_MATERIAS_SUCCESS:
      return {
        ...state,
        materias: Array.isArray(action.payload) ? action.payload : [],
        materiasFetching: false,
        materiasError: null,
      };
    case types.GET_FOROS_MATERIAS_FAILURE:
      return {
        ...state,
        materiasFetching: false,
        materiasError: action.payload,
      };

    case types.GET_FOROS_HILOS_BEGINS:
      return {
        ...state,
        hilosMateriaId: action.idMateria,
        hilosFetching: true,
        hilosError: null,
      };
    case types.GET_FOROS_HILOS_SUCCESS:
      return {
        ...state,
        hilos: {
          items: Array.isArray(action.payload?.items) ? action.payload.items : [],
          page: action.payload?.page || 1,
          pageSize: action.payload?.pageSize || 100,
          totalItems: action.payload?.totalItems || 0,
          totalPages: action.payload?.totalPages || 0,
        },
        hilosFetching: false,
        hilosError: null,
      };
    case types.GET_FOROS_HILOS_FAILURE:
      return {
        ...state,
        hilosFetching: false,
        hilosError: action.payload,
      };

    case types.GET_FORO_HILO_DETALLE_BEGINS:
      return {
        ...state,
        hiloDetalleFetching: true,
        hiloDetalleError: null,
      };
    case types.GET_FORO_HILO_DETALLE_SUCCESS:
      return {
        ...state,
        hiloDetalle: action.payload || null,
        hiloDetalleFetching: false,
        hiloDetalleError: null,
      };
    case types.GET_FORO_HILO_DETALLE_FAILURE:
      return {
        ...state,
        hiloDetalleFetching: false,
        hiloDetalleError: action.payload,
      };

    case types.POST_FORO_HILO_BEGINS:
      return {
        ...state,
        hiloStatusFetching: true,
        hiloStatusError: null,
      };
    case types.POST_FORO_HILO_SUCCESS:
      return {
        ...state,
        hiloStatus: action.payload?.status || 200,
        hiloStatusData: action.payload?.data || action.payload,
        hiloStatusFetching: false,
        hiloStatusError: null,
      };
    case types.POST_FORO_HILO_FAILURE:
      return {
        ...state,
        hiloStatusFetching: false,
        hiloStatusError: action.payload,
      };
    case types.RESET_POST_FORO_HILO:
      return {
        ...state,
        hiloStatus: null,
        hiloStatusData: null,
        hiloStatusFetching: false,
        hiloStatusError: null,
      };

    case types.POST_FORO_RESPUESTA_BEGINS:
      return {
        ...state,
        respuestaStatusFetching: true,
        respuestaStatusError: null,
      };
    case types.POST_FORO_RESPUESTA_SUCCESS:
      return {
        ...state,
        respuestaStatus: action.payload?.status || 200,
        respuestaStatusData: action.payload?.data || action.payload,
        respuestaStatusFetching: false,
        respuestaStatusError: null,
      };
    case types.POST_FORO_RESPUESTA_FAILURE:
      return {
        ...state,
        respuestaStatusFetching: false,
        respuestaStatusError: action.payload,
      };
    case types.RESET_POST_FORO_RESPUESTA:
      return {
        ...state,
        respuestaStatus: null,
        respuestaStatusData: null,
        respuestaStatusFetching: false,
        respuestaStatusError: null,
      };

    case types.DELETE_FORO_HILO_BEGINS:
      return {
        ...state,
        deleteHiloStatusFetching: true,
        deleteHiloStatusError: null,
      };
    case types.DELETE_FORO_HILO_SUCCESS: {
      const deletedId = action.payload?.data?.id || action.payload?.id;
      const currentItems = Array.isArray(state.hilos?.items) ? state.hilos.items : [];

      return {
        ...state,
        hilos: {
          ...state.hilos,
          items: deletedId ? currentItems.filter(hilo => hilo.id !== deletedId) : currentItems,
          totalItems: deletedId && state.hilos?.totalItems > 0
            ? state.hilos.totalItems - 1
            : state.hilos?.totalItems || 0,
        },
        hiloDetalle: deletedId && state.hiloDetalle?.id === deletedId ? null : state.hiloDetalle,
        deleteHiloStatus: action.payload?.status || 200,
        deleteHiloStatusData: action.payload?.data || action.payload,
        deleteHiloStatusFetching: false,
        deleteHiloStatusError: null,
      };
    }
    case types.DELETE_FORO_HILO_FAILURE:
      return {
        ...state,
        deleteHiloStatusFetching: false,
        deleteHiloStatusError: action.payload,
      };
    case types.RESET_DELETE_FORO_HILO:
      return {
        ...state,
        deleteHiloStatus: null,
        deleteHiloStatusData: null,
        deleteHiloStatusFetching: false,
        deleteHiloStatusError: null,
      };

    case types.DELETE_FORO_RESPUESTA_BEGINS:
      return {
        ...state,
        deleteRespuestaStatusFetching: true,
        deleteRespuestaStatusError: null,
      };
    case types.DELETE_FORO_RESPUESTA_SUCCESS:
      return {
        ...state,
        hiloDetalle: action.payload?.data || state.hiloDetalle,
        deleteRespuestaStatus: action.payload?.status || 200,
        deleteRespuestaStatusData: action.payload?.data || action.payload,
        deleteRespuestaStatusFetching: false,
        deleteRespuestaStatusError: null,
      };
    case types.DELETE_FORO_RESPUESTA_FAILURE:
      return {
        ...state,
        deleteRespuestaStatusFetching: false,
        deleteRespuestaStatusError: action.payload,
      };
    case types.RESET_DELETE_FORO_RESPUESTA:
      return {
        ...state,
        deleteRespuestaStatus: null,
        deleteRespuestaStatusData: null,
        deleteRespuestaStatusFetching: false,
        deleteRespuestaStatusError: null,
      };

    case types.CLEAR_FORO_HILOS:
      return {
        ...state,
        hilos: initialState.hilos,
        hilosMateriaId: null,
        hilosFetching: false,
        hilosError: null,
      };
    case types.CLEAR_FORO_DETALLE:
      return {
        ...state,
        hiloDetalle: null,
        hiloDetalleFetching: false,
        hiloDetalleError: null,
        respuestaStatus: null,
        respuestaStatusData: null,
        respuestaStatusError: null,
        hiloStatus: null,
        hiloStatusData: null,
        hiloStatusError: null,
        deleteHiloStatus: null,
        deleteHiloStatusData: null,
        deleteHiloStatusError: null,
        deleteRespuestaStatus: null,
        deleteRespuestaStatusData: null,
        deleteRespuestaStatusError: null,
      };
    default:
      return state;
  }
}

export const actions = {
  getMaterias: force => ({ type: types.GET_FOROS_MATERIAS_BEGINS, force }),
  successGetMaterias: data => ({ type: types.GET_FOROS_MATERIAS_SUCCESS, payload: data }),
  errorGetMaterias: error => ({ type: types.GET_FOROS_MATERIAS_FAILURE, payload: error }),

  getHilosMateria: (idMateria, page = 1, pageSize = 100, force = false) => ({
    type: types.GET_FOROS_HILOS_BEGINS,
    idMateria,
    page,
    pageSize,
    force,
  }),
  successGetHilosMateria: data => ({ type: types.GET_FOROS_HILOS_SUCCESS, payload: data }),
  errorGetHilosMateria: error => ({ type: types.GET_FOROS_HILOS_FAILURE, payload: error }),

  getHiloDetalle: (idHilo, force = false) => ({ type: types.GET_FORO_HILO_DETALLE_BEGINS, idHilo, force }),
  successGetHiloDetalle: data => ({ type: types.GET_FORO_HILO_DETALLE_SUCCESS, payload: data }),
  errorGetHiloDetalle: error => ({ type: types.GET_FORO_HILO_DETALLE_FAILURE, payload: error }),

  postHilo: (idMateria, idPregunta, asunto, cuerpo) => ({
    type: types.POST_FORO_HILO_BEGINS,
    idMateria,
    idPregunta,
    asunto,
    cuerpo,
  }),
  successPostHilo: data => ({ type: types.POST_FORO_HILO_SUCCESS, payload: data }),
  errorPostHilo: error => ({ type: types.POST_FORO_HILO_FAILURE, payload: error }),
  resetPostHilo: () => ({ type: types.RESET_POST_FORO_HILO }),

  postRespuesta: (idHilo, cuerpo) => ({ type: types.POST_FORO_RESPUESTA_BEGINS, idHilo, cuerpo }),
  successPostRespuesta: data => ({ type: types.POST_FORO_RESPUESTA_SUCCESS, payload: data }),
  errorPostRespuesta: error => ({ type: types.POST_FORO_RESPUESTA_FAILURE, payload: error }),
  resetPostRespuesta: () => ({ type: types.RESET_POST_FORO_RESPUESTA }),

  deleteHilo: (idHilo, idMateria, page = 1, pageSize = 100) => ({
    type: types.DELETE_FORO_HILO_BEGINS,
    idHilo,
    idMateria,
    page,
    pageSize,
  }),
  successDeleteHilo: data => ({ type: types.DELETE_FORO_HILO_SUCCESS, payload: data }),
  errorDeleteHilo: error => ({ type: types.DELETE_FORO_HILO_FAILURE, payload: error }),
  resetDeleteHilo: () => ({ type: types.RESET_DELETE_FORO_HILO }),

  deleteRespuesta: (idRespuesta, idMateria, page = 1, pageSize = 100) => ({
    type: types.DELETE_FORO_RESPUESTA_BEGINS,
    idRespuesta,
    idMateria,
    page,
    pageSize,
  }),
  successDeleteRespuesta: data => ({ type: types.DELETE_FORO_RESPUESTA_SUCCESS, payload: data }),
  errorDeleteRespuesta: error => ({ type: types.DELETE_FORO_RESPUESTA_FAILURE, payload: error }),
  resetDeleteRespuesta: () => ({ type: types.RESET_DELETE_FORO_RESPUESTA }),

  clearHilos: () => ({ type: types.CLEAR_FORO_HILOS }),
  clearDetalle: () => ({ type: types.CLEAR_FORO_DETALLE }),
}

export default ForosReducer;
